/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 事業作成元種別
 */
export type ProjectSourceType = (typeof ProjectSourceType)[keyof typeof ProjectSourceType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProjectSourceType = {
  euc: 'euc',
  manual: 'manual',
} as const;
